export enum UserStatus {
    active = 'active',
    pending_review = 'pending_review',
    pending_kyc = 'pending_kyc',
    disabled = 'disabled',
}
